import MainButtonArray from './MainButtonArray';

export default MainButtonArray;
